import React, { useRef } from "react";
import style from "./index.module.scss";
import { useUpdateEffect } from "react-use";
import { Modal } from "antd";
import GetScript from "../GetScript";

declare global {
    interface Window {
        polyvPlayer: any;
    }
}

interface VideoViewerProps {
    vid: string;
}

export default function VideoViewer({ vid }: VideoViewerProps) {
    const playerRef = useRef<any>(null);

    useUpdateEffect(() => {
        if (!playerRef.current) return;
        playerRef.current.changeVid({ vid, autoplay: false });
    }, [vid]);

    function onLoad() {
        playerRef.current = window.polyvPlayer({
            wrap: `#video${vid}`,
            height: "100%",
            vid: vid,
            autoplay: false
        });
    }

    function onError() {
        Modal.error({ content: "播放器加载失败!", getContainer });
    }

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <GetScript
            key={vid}
            src="//player.polyv.net/script/player.js"
            onLoad={onLoad}
            onError={onError}>
            <div id={`video${vid}`} className={style.video} />
        </GetScript>
    );
}
